import type { SavedViz } from './SavedViz.js'

const LS_KEY = 'viz:savedViews:v1'

export type SavedViewEntry = {
  id: string // uuid-ish
  name: string // user-facing title
  savedAt: number // epoch ms
  data: SavedViz
}

function readAll(): SavedViewEntry[] {
  try {
    const raw = localStorage.getItem(LS_KEY)
    return raw ? (JSON.parse(raw) as SavedViewEntry[]) : []
  } catch {
    return []
  }
}

function writeAll(list: SavedViewEntry[]) {
  localStorage.setItem(LS_KEY, JSON.stringify(list))
}

export const SavedViewsStore = {
  list(): SavedViewEntry[] {
    return readAll().sort((a, b) => b.savedAt - a.savedAt)
  },
  add(name: string, data: SavedViz): SavedViewEntry {
    const entry: SavedViewEntry = {
      id: `view:${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      name,
      savedAt: Date.now(),
      data
    }
    const list = readAll()
    list.push(entry)
    writeAll(list)
    return entry
  },
  remove(id: string) {
    writeAll(readAll().filter((e) => e.id !== id))
  },
  get(id: string): SavedViewEntry | undefined {
    return readAll().find((e) => e.id === id)
  }
}
